/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { BaseButton, Props as BaseButtonProps } from '../Button/BaseButton';

export type Props = Omit<BaseButtonProps, 'isPill'> & {
  color?: 'primary' | 'secondary';
  size?: 'small' | 'large';
};

// These map to *-dark data-color attributes that are used for styling
// In styling you'll look for [data-color='primary-dark'], for example
// This mapping makes it simpler for consumers to pass in props
const colorMappings: Record<string, BaseButtonProps['color']> = {
  primary: 'primary-dark',
  secondary: 'secondary-dark',
};
/**
 * A Button for Dark backgrounds.
 */

export function DarkBackgroundButton({
  size = 'small',
  color = 'primary',
  ...props
}: Props) {
  return <BaseButton color={colorMappings[color]} size={size} {...props} />;
}
